module.exports = __webpack_public_path__ + "static/media/carousel-image1.65681d55.png";